import { useState, type CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
import { LogoMark } from './Logo'

// Picks up the timing of the loading screen this one replaces (index.html's, or a guard's), so the line carries on instead of restarting.
function carriedTiming(): CSSProperties {
  const running = typeof document.getAnimations === 'function' ? document.getAnimations() : []
  const delay = (name: string) => {
    const a = running.find((x) => (x as CSSAnimation).animationName === name)
    const time = a?.currentTime
    if (!a?.effect || typeof time !== 'number') return undefined
    return `${Number(a.effect.getTiming().delay ?? 0) - time}ms`
  }
  return { '--boot-show': delay('boot-show'), '--boot-slide': delay('boot-slide') } as CSSProperties
}

// The same markup and classes as the loading screen in index.html; its styles live there.
export default function BootScreen() {
  const { t } = useTranslation()
  const [style] = useState(carriedTiming)
  return (
    <div className="boot" role="status" aria-live="polite" style={style}>
      <div className="boot-in">
        <LogoMark className="boot-mark" />
        <div className="boot-line" />
      </div>
      <span className="boot-sr">{t('loading')}</span>
    </div>
  )
}
